/* src/components/Toolbar/Toolbar.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	attr,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_style,
	space,
	subscribe,
	svg_element,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { writable as svelte_writable } from "svelte/store";
import { height } from "../../actions/height";
import { clamp } from "../helpers";
import Contents from "./components/Contents.svelte";

function create_else_block(ctx) {
	let path0;
	let path0_class_value;
	let path1;
	let path1_class_value;

	return {
		c() {
			path0 = svg_element("path");
			path1 = svg_element("path");
			attr(path0, "stroke", "#000");
			attr(path0, "d", "M20 52v16");
			attr(path0, "class", path0_class_value = "" + (name + "-handler-image-stroke-color"));
			attr(path1, "fill", "#000");
			attr(path1, "stroke", "none");
			attr(path1, "d", "M16 52v16l-8-8z");
			attr(path1, "class", path1_class_value = "" + (name + "-handler-image-fill-color"));
		},
		m(target, anchor) {
			insert(target, path0, anchor);
			insert(target, path1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(path0);
			if (detaching) detach(path1);
		}
	};
}

// (49:6) {#if collapsed}
function create_if_block(ctx) {
	let path0;
	let path0_class_value;
	let path1;
	let path1_class_value;

	return {
		c() {
			path0 = svg_element("path");
			path1 = svg_element("path");
			attr(path0, "stroke", "#000");
			attr(path0, "d", "M10 52v16");
			attr(path0, "class", path0_class_value = "" + (name + "-handler-image-stroke-color"));
			attr(path1, "fill", "#000");
			attr(path1, "stroke", "none");
			attr(path1, "d", "M14 52v16l8-8z");
			attr(path1, "class", path1_class_value = "" + (name + "-handler-image-fill-color"));
		},
		m(target, anchor) {
			insert(target, path0, anchor);
			insert(target, path1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(path0);
			if (detaching) detach(path1);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let contents;
	let div0_class_value;
	let t0;
	let label;
	let input;
	let t1;
	let svg;
	let path0;
	let path0_class_value;
	let path1;
	let path1_class_value;
	let label_class_value;
	let div1_class_value;
	let height_action;
	let current;
	let mounted;
	let dispose;

	contents = new Contents({
			props: {
				app: /*app*/ ctx[0],
				theme: /*theme*/ ctx[1],
				language: /*language*/ ctx[2],
				disabled: /*disabled*/ ctx[7],
				scroll_height: /*scroll_height*/ ctx[10],
				computed_height: /*computed_height*/ ctx[6],
				scrollable: /*scrollable*/ ctx[5],
				hide_apps: /*hide_apps*/ ctx[4]
			}
		});

	function select_block_type(ctx, dirty) {
		if (/*collapsed*/ ctx[3]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			create_component(contents.$$.fragment);
			t0 = space();
			label = element("label");
			input = element("input");
			t1 = space();
			svg = svg_element("svg");
			path0 = svg_element("path");
			path1 = svg_element("path");
			if_block.c();
			attr(div0, "class", div0_class_value = "" + (name + "-contents " + /*theme*/ ctx[1]));

			set_style(div0, "height", /*scrollable*/ ctx[5]
			? /*computed_height*/ ctx[6] + "px"
			: "auto");

			attr(input, "type", "checkbox");
			attr(path0, "fill", "#fff");
			attr(path0, "stroke", "none");
			attr(path0, "d", "m0 0 24 16q6 4 6 14v60q0 10-6 14L0 120");
			attr(path0, "class", path0_class_value = "" + (name + "-handler-bg-color"));
			attr(path1, "stroke", "#000");
			attr(path1, "d", "m0 0 24 16q6 4 6 14v60q0 10-6 14L0 120");
			attr(path1, "class", path1_class_value = "" + (name + "-handler-border-color"));
			attr(svg, "fill", "none");
			attr(svg, "stroke-width", "2");
			attr(svg, "viewBox", "0 0 32 120");
			attr(label, "class", label_class_value = "" + (name + "-handler " + /*theme*/ ctx[1]));
			attr(div1, "class", div1_class_value = "" + (name + " " + /*theme*/ ctx[1]));
			toggle_class(div1, "collapsed", /*collapsed*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			mount_component(contents, div0, null);
			append(div1, t0);
			append(div1, label);
			append(label, input);
			input.checked = /*collapsed*/ ctx[3];
			append(label, t1);
			append(label, svg);
			append(svg, path0);
			append(svg, path1);
			if_block.m(svg, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_handler*/ ctx[15]),
					action_destroyer(height_action = height.call(null, div1, /*container_height*/ ctx[9]))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const contents_changes = {};
			if (dirty & /*app*/ 1) contents_changes.app = /*app*/ ctx[0];
			if (dirty & /*theme*/ 2) contents_changes.theme = /*theme*/ ctx[1];
			if (dirty & /*language*/ 4) contents_changes.language = /*language*/ ctx[2];
			if (dirty & /*disabled*/ 128) contents_changes.disabled = /*disabled*/ ctx[7];
			if (dirty & /*computed_height*/ 64) contents_changes.computed_height = /*computed_height*/ ctx[6];
			if (dirty & /*scrollable*/ 32) contents_changes.scrollable = /*scrollable*/ ctx[5];
			if (dirty & /*hide_apps*/ 16) contents_changes.hide_apps = /*hide_apps*/ ctx[4];
			contents.$set(contents_changes);

			if (!current || dirty & /*theme*/ 2 && div0_class_value !== (div0_class_value = "" + (name + "-contents " + /*theme*/ ctx[1]))) {
				attr(div0, "class", div0_class_value);
			}

			if (dirty & /*scrollable, computed_height*/ 96) {
				set_style(div0, "height", /*scrollable*/ ctx[5]
				? /*computed_height*/ ctx[6] + "px"
				: "auto");
			}

			if (dirty & /*collapsed*/ 8) {
				input.checked = /*collapsed*/ ctx[3];
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(svg, null);
				}
			}

			if (!current || dirty & /*theme*/ 2 && label_class_value !== (label_class_value = "" + (name + "-handler " + /*theme*/ ctx[1]))) {
				attr(label, "class", label_class_value);
			}

			if (!current || dirty & /*theme*/ 2 && div1_class_value !== (div1_class_value = "" + (name + " " + /*theme*/ ctx[1]))) {
				attr(div1, "class", div1_class_value);
			}

			if (!current || dirty & /*theme, collapsed*/ 10) {
				toggle_class(div1, "collapsed", /*collapsed*/ ctx[3]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(contents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(contents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(contents);
			if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

const name = "fastboard-toolbar";

function instance($$self, $$props, $$invalidate) {
	let writable;
	let disabled;
	let computed_height;
	let scrollable;
	let hide_apps;
	let $container_height;
	let $scroll_height;

	let $writable,
		$$unsubscribe_writable = noop,
		$$subscribe_writable = () => ($$unsubscribe_writable(), $$unsubscribe_writable = subscribe(writable, $$value => $$invalidate(14, $writable = $$value)), writable);

	$$self.$$.on_destroy.push(() => $$unsubscribe_writable());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { config = {} } = $$props;
	const extra_height = (32 + 4 + 4) * 2;
	let collapsed = false;
	let container_height = svelte_writable(0);
	component_subscribe($$self, container_height, value => $$invalidate(12, $container_height = value));
	let scroll_height = svelte_writable(0);
	component_subscribe($$self, scroll_height, value => $$invalidate(13, $scroll_height = value));

	function input_change_handler() {
		collapsed = this.checked;
		$$invalidate(3, collapsed);
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(0, app = $$props.app);
		if ('theme' in $$props) $$invalidate(1, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(2, language = $$props.language);
		if ('config' in $$props) $$invalidate(11, config = $$props.config);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*app*/ 1) {
			$: $$subscribe_writable($$invalidate(8, writable = app?.writable));
		}

		if ($$self.$$.dirty & /*$writable*/ 16384) {
			$: $$invalidate(7, disabled = !$writable);
		}

		if ($$self.$$.dirty & /*$container_height, $scroll_height*/ 12288) {
			$: $$invalidate(6, computed_height = clamp($container_height, extra_height, $scroll_height + extra_height));
		}

		if ($$self.$$.dirty & /*$scroll_height, $container_height*/ 12288) {
			$: $$invalidate(5, scrollable = $scroll_height + extra_height > $container_height);
		}

		if ($$self.$$.dirty & /*config*/ 2048) {
			$: $$invalidate(4, hide_apps = config.apps?.enable === false);
		}
	};

	return [
		app,
		theme,
		language,
		collapsed,
		hide_apps,
		scrollable,
		computed_height,
		disabled,
		writable,
		container_height,
		scroll_height,
		config,
		$container_height,
		$scroll_height,
		$writable,
		input_change_handler
	];
}

class Toolbar extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			app: 0,
			theme: 1,
			language: 2,
			config: 11
		});
	}
}

export default Toolbar;